<template>
  <el-dialog
    destroy-on-close
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="50%"
    center
    class="hb-radiogroup-dialog"
    @open="openAction"
  >
    <div class="main-wrapper">
      <el-radio-group v-model="radio" class="content-wrapper">
        <div v-for="item in dataSource" :key="item.vaule" class="content-item">
          <div class="radio-wrapper">
            <el-radio :label="item.value">{{ item.label }}</el-radio>
          </div>
          <div :class="item.value == radio ? 'desc desc-show' : 'desc desc-hide'">{{ item.desc }}</div>
        </div>
      </el-radio-group>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirmAction">确定</el-button>
    </div>
  </el-dialog>
</template>
  
  <script>
export default {
  name: "HBRadioGroupDialog",
  props: {
    dialogTitle: {
      type: String,
      default: "请选择",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array, //[{label:'测试1',value:1,default:true},{label:'测试2',value:2,default:false}]
      default: [],
    },
  },
  data() {
    return {
      radio: null,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("updateVisible", val);
      },
    },
  },
  methods: {
    desc() {
      const index = this.dataSource.findIndex(
        (item) => item.value == this.radio
      );
      if (index >= 0) {
        const d = this.dataSource[index].desc || "";
        return d;
      } else {
        return "";
      }
    },
    openAction() {
      for (let i = 0; i < this.dataSource.length; i++) {
        const item = this.dataSource[i];
        if (item.default) {
          this.radio = item.value;
          break;
        }
      }
    },
    confirmAction() {
      if (this.radio == null || this.radio == undefined) {
        this.$message.error("请选择");
        return;
      }
      this.dialogVisible = false;
      this.$emit("confirmCallback", this.radio);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.hb-radiogroup-dialog {
  .main-wrapper {
    padding: 0 70px;
    .content-wrapper {
      display: flex;
      flex-direction: column;
      align-content: flex-start;
      justify-content: flex-start;
      .content-item {
        margin-bottom: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        label {
          margin-bottom: 0 !important;
        }
        .radio-wrapper {
          min-width: 120px;
        }
        .desc {
          flex: 1;
          
          color: #f56c6c;
          
        }
        .desc-show {
          font-size: 14px;
        }
        .desc-hide {
          font-size: 0px;
        }
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/HBCommon/HBRadioGroupDialog/HBRadioGroupDialog.vue